import request from '@/utils/request'

//错题集
export function topiclist(data) {
	return request({
		url: '/courseTask/topic/list',
		method: 'get',
		params: data
	})
}

//查询课程作业的错题
export function getUserTaskErrorTopic(data) {
	return request({
		url: '/courseTask/topic/getUserTaskErrorTopic',
		method: 'get',
		params: data
	})
}
//查询课程作业的错题详情
export function getUserErrorInfo(data) {
	return request({
		url: '/courseTask/topic/getUserErrorInfo',
		method: 'get',
		params: data
	})
}
//查询考核中的错题
export function getUserExamErrorTopic(data) {
	return request({
		url: '/courseTask/topic/getUserExamErrorTopic',
		method: 'get',
		params: data
	})
}
//查询课程考核的错题详情
export function getUserExamErrorInfo(data) {
	return request({
		url: '/courseTask/topic/getUserExamErrorInfo',
		method: 'get',
		params: data
	})
}

//查询实验中测验的错题
export function getUserErrorTopic(data) {
	return request({
		url: '/api/userErrorTopic/getUserErrorTopic',
		method: 'get',
		params: data
	})
}
//查询实验中测验的错题详情
export function getExperErrorInfo(data) {
	return request({
		url: '/api/userErrorTopic/getUserErrorInfo',
		method: 'get',
		params: data
	})
}

//查询自测错题
export function getUserSeltTestTopic(data) {
	return request({
		url: '/courseTask/topic/getUserSeltTestTopic',
		method: 'get',
		params: data
	})
}
//查询自测错题详情
export function getUserSeltTestTopicDetail(data) {
	return request({
		url: '/courseTask/topic/getUserSeltTestTopicDetail',
		method: 'get',
		params: data
	})
}